export const INVITE_LABEL = { none: "Not invited", invited: "Invited", reminded: "Reminded", claimed: "Signed up", failed: "Invite failed" };

export const inviteState = (l) => {
  const ci = l.claim_invite || {};
  if (l.status === "Won") return ["claimed", null];
  if (ci.last_ok === false) return ["failed", ci.last_try_at];
  if (ci.reminded_at) return ["reminded", ci.reminded_at];
  if (ci.sent_at) return ["invited", ci.sent_at];
  return ["none", null];
};

const COLORS = { none: "bg-slate-100 text-slate-500", invited: "bg-blue-100 text-blue-700", reminded: "bg-violet-100 text-violet-700", claimed: "bg-emerald-100 text-emerald-700", failed: "bg-red-100 text-red-700" };

export const InviteBadge = ({ lead, testId }) => {
  const [s, at] = inviteState(lead);
  return <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded whitespace-nowrap ${COLORS[s]}`} title={lead.claim_invite?.last_error || ""} data-testid={testId}>{INVITE_LABEL[s]}{at ? ` · ${new Date(at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}` : ""}</span>;
};
